import React from 'react';
import { Route } from '../Routing/types';
import AllSettingsPage from './AllSettingsPage';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/all-settings/*',
    element: <AllSettingsPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: dummy_t('allSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
